import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { pathOr } from 'ramda';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import {
  AgentContainer,
  Container,
  RowContainer,
  SelectContainer,
  Title,
} from './style';

class Agent extends Component {
  onSelectChange = (event) => {
    const { assignAgentToService, id } = this.props;
    const agent = event.target.value === 'unassign' ? null : event.target.value;
    assignAgentToService({ agentId: agent, serviceId: id });
  };

  render() {
    const {
      agents, value, areas,
    } = this.props;

    const isAreaAvailable = areas.length > 0;

    const agentsForArea = isAreaAvailable ? pathOr([], ['data', areas[0].code, 'users'], agents) : [];

    return (
      <Fragment>
        <Container>
          <RowContainer>
            <Title>Agent</Title>
            <AgentContainer>
              <SelectContainer>
                <Select disabled={!isAreaAvailable} value={value || 'unassign'} onChange={this.onSelectChange}>
                  <MenuItem value="unassign">Unassign</MenuItem>
                  {agentsForArea.map(({ _id: agentId, name: agentName }) => (
                    <MenuItem
                      key={agentId}
                      value={agentId}
                    >
                      {agentName}
                    </MenuItem>
                  ))}
                </Select>
              </SelectContainer>
            </AgentContainer>
          </RowContainer>
        </Container>
      </Fragment>
    );
  }
}
Agent.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.shape({
    _id : PropTypes.string,
    code: PropTypes.string,
  })),
  agents: PropTypes.shape({
    data: PropTypes.shape({
      _id : PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  assignAgentToService: PropTypes.func,
  id                  : PropTypes.string,
  value               : PropTypes.string,
};
Agent.defaultProps = {
  areas : [],
  agents: {},
  assignAgentToService() {},
  id    : '',
  value : '',
};

export default Agent;
